export const ApiEnum = {
    EMPLOYEE: import.meta.env.VITE_ADMIN_URL + "/api/v2/employee",
    CERTIFICATE: import.meta.env.VITE_ADMIN_URL + "/api/v2/certificate",
    ESTABLISHMENT: import.meta.env.VITE_ADMIN_URL + "/api/v2/establishment",
    COMPLIANCE_EXPORT:
        import.meta.env.VITE_ADMIN_URL +
        "/api/v2/establishment/compliance-export",
    FUNCTION_GROUP: import.meta.env.VITE_ADMIN_URL + "/api/v2/function-group",
    QUALIFICATION_STANDARD:
        import.meta.env.VITE_ADMIN_URL + "/api/v2/qualification-standard",
    QUALIFICATION: import.meta.env.VITE_ADMIN_URL + "/api/v2/qualification",
    NOTIFICATION: import.meta.env.VITE_ADMIN_URL + "/api/v2/notification",
    EDUCATOR: import.meta.env.VITE_ADMIN_URL + "/api/v2/educator",
    SCHEDULED_QUALIFICATION:
        import.meta.env.VITE_ADMIN_URL + "/api/v2/scheduled-qualification",
    // LMS list endpoints use page + items_per_page (confirmed in CertificateExpiryController)
    EMPLOYEE_EXPIRED_CERTIFICATE:
        import.meta.env.VITE_ADMIN_URL +
        "/api/lms/employee/expired-certificate",
    ESTABLISHMENT_EXPIRED_CERTIFICATE:
        import.meta.env.VITE_ADMIN_URL + "/api/lms/establishment",
};
